<input *ngFor="let ctr of optionsList; let i = index"
       [type]="multiple ? 'checkbox' : 'radio'"
       [name]="ctr.id"
       id="item-{{ctr.id ? ctr.id : i}}"
       [value]="multiple ? ctr.checked : ctr.id"
       [checked]="multiple ? ctr.checked : value === ctr.id"
       [tabindex]="tabInd"  
/>

<div [ngClass]="{bordered: bordered, horizontal: isHorizontal, borderedNoBackground: borderedNoBackground}"
     class="options-wrapper"
     #optionsWrapper
>
  <div class="option"
       *ngFor="let option of optionsList; let i = index; let first = first; let last = last"
       [ngClass]="{multiple: multiple,
        checked: multiple ? option.checked : value === option.id,
        first: first,
        last: last,
        disabled: isDisabled(option.id)}"
        [class.error]="(control.touched && control.invalid)"
       (click)="multiple ? toggleValue(i) : selectOption(option)"
       [tabIndex]="1"
       #optionsList
  >
    <label *ngIf="hasCustomTemplate" class="content-wrapper" for="item-{{option.id ? option.id : i}}">
      <ng-content *ngTemplateOutlet="templateRef; context:{ $implicit: option, idx: i }"></ng-content>
    </label>

    <label *ngIf="!hasCustomTemplate" class="label" for="item-{{option.id ? option.id : i}}">
      <span>{{option.name}}</span> <a *ngIf="option?.link" class="link" (click)="linkClicked.emit(option?.id)">{{option.link}}</a>
      <div *ngIf="option && option[secondaryProp]" class="description">
        {{option[secondaryProp]}}
      </div>
    </label>
  </div>
</div>
